import { z } from 'zod';

import {
  CONTRACT_IMPORT_MAX_FILE_SIZE_BYTES,
  CONTRACT_IMPORT_MAX_FILES,
} from '../constants';
import { zodContractImportJobSummarySchema } from '../validations';

// One file to create an import job from. The API only accepts PDFs.
export const zodCreateContractImportJobItemPayloadSchema = z.object({
  fileId: z.uuid(),
  fileMime: z.literal('application/pdf'),
  fileName: z.string(),
  fileSizeBytes: z
    .number()
    .int()
    .min(0)
    .max(CONTRACT_IMPORT_MAX_FILE_SIZE_BYTES)
    .optional(),
});

// Request payload schema for bulk-creating contract import jobs.
export const zodCreateContractImportJobsPayloadSchema = z.object({
  jobs: z
    .array(zodCreateContractImportJobItemPayloadSchema)
    .max(CONTRACT_IMPORT_MAX_FILES),
});

// Response schema for bulk-created contract import jobs.
export const zodCreateContractImportJobsResponseSchema = z.object({
  data: z.array(zodContractImportJobSummarySchema),
});
